import './App.css';
import MainPage from './views/MainPage/MainPage.jsx';
import AIPlatform from './views/AIPlatform/AIPlatform.jsx';

import AboutUs from './views/AboutUs/AboutUs.jsx';

import Contact from './views/Contact/Contact.jsx';
import ForHome from './views/ForHome/ForHome.jsx';

import Profile from './views/Profile/Profile.jsx';
import CreateModel from './views/CreateModel/CreateModel.jsx';
import NotFound from './views/NotFound/NotFound.jsx';
import ForgotPassword from './views/ForgotPassword/ForgotPassword.jsx';
import FAQ from './views/FAQ/FAQ.jsx';
import { AuthProvider } from './AuthContext.jsx';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import client from './apollo-client';
import './i18n/i18n';
import Footer from './components/Footer/Footer';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy'; 
import CookiePolicy from './components/CookiePolicy/CookiePolicy';
import TermsAndConditions from './components/TermsAndCondition/TermsAndCondition';
import CookieBanner from './components/CookiePolicyBanner/CookiePolicyBanner';
import Landing from './views/Landing/Landing.jsx';
import Survey from './views/Survey/Survey.jsx';

console.log("Entorno actual:", process.env.REACT_APP_ENV);

function App() {
  return (
    <Router>
      <ApolloProvider client={client}>
        <AuthProvider>
          <ScrollToTop />

    
          <CookieBanner />

          <Routes>
            <Route path="/" element={<MainPage />} />
            <Route path="/ai-platform" element={<AIPlatform />} />
            <Route path="/ForgotPassword" element={<ForgotPassword />} />
            <Route path="/AboutUs" element={<AboutUs />} />
            <Route path="/Contact" element={<Contact />} />
            <Route path="/ForHome" element={<ForHome />} />
            <Route path="/Profile" element={<Profile />} />
            <Route path="/CreateModel" element={<CreateModel />} />
            <Route path="/FAQ" element={<FAQ />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/cookiePolicy" element={<CookiePolicy />} />
            <Route path="/termsAndConditions" element={<TermsAndConditions />} />
            <Route path="/Landing" element={<Landing />} />
            <Route path="/Survey" element={<Survey />} />
            
            <Route path="*" element={<NotFound />} />
          </Routes>

          <Footer />

        </AuthProvider>
      </ApolloProvider>
    </Router>
  );
}

export default App;
